module.exports = __webpack_public_path__ + "static/media/B3.212fea62.png";